import { BroadcastTopics } from 'services/wsService';

import { useWebsocketRoom } from '../websockets/use-room';
import { useSocketOn } from '../websockets/use-socket-on';
import { useUpdatePatientInfoCache } from './use-update-patient-info-cache';

import type { RpmStatuses } from 'infrastructure/enums';

interface ISocketData {
  status: RpmStatuses;
}

interface Props {
  patientGuid: string;
}

export const useRealTimeUpdatePatientStatus = ({ patientGuid }: Props) => {
  const { updateCache } = useUpdatePatientInfoCache();

  useWebsocketRoom('rpmPatientProfile', { patientGuid });
  useSocketOn(BroadcastTopics.PatientStatusChange, (data: ISocketData) => {
    updateQueryPatientStatus(data);
  });

  const updateQueryPatientStatus = (socketData: ISocketData) => {
    updateCache(patientGuid, { status: socketData.status });
  };
};
